import React from "react";
import { Monitor, Layers, Globe, ArrowUpRight, ChevronRight } from "lucide-react";
import PageHero from "@/components/public/PageHero";
import { useSite } from "@/context/SiteContext";

const PLATFORMS = [
  { name: "MetaTrader 4", key: "mt4_download", webKey: "mt4_web", Icon: Monitor, desc: "The industry-standard platform for forex and CFD trading, trusted by millions worldwide.", features: ["Expert Advisors (EAs)", "9 timeframes", "30+ built-in indicators", "One-click trading"] },
  { name: "MetaTrader 5", key: "mt5_download", webKey: "mt5_web", Icon: Layers, desc: "A next-generation multi-asset platform with advanced analytical tools and market depth.", features: ["21 timeframes", "Depth of Market", "Economic calendar", "38 technical indicators"] },
  { name: "Cresent WebTrader", key: "webtrader", webKey: "webtrader", Icon: Globe, desc: "Trade directly from your browser with no installation — your account, anywhere.", features: ["Browser-based access", "Cross-device sync", "Real-time charts", "Instant execution"] },
];

export default function Platforms() {
  const { trackAndGo } = useSite();
  return (
    <div>
      <PageHero overline="Platforms" title="Professional Trading Platforms" subtitle="Choose MT4, MT5 or the Cresent WebTrader — all connected to the same institutional liquidity." image="/images/platforms_3d_devices.jpg" />
      <section className="py-16 sm:py-24 bg-white">
        <div className="cb-container grid md:grid-cols-3 gap-6">
          {PLATFORMS.map((p) => (
            <div key={p.name} className="cb-card p-8 flex flex-col" data-testid={`platforms-card-${p.key}`}>
              <p.Icon className="gold-text mb-5" size={36} />
              <h3 className="font-serif text-2xl text-[#0B1D40] mb-2">{p.name}</h3>
              <p className="text-slate-500 text-sm leading-relaxed mb-5">{p.desc}</p>
              <ul className="space-y-2 mb-6 flex-1">
                {p.features.map((f) => <li key={f} className="flex items-center gap-2 text-sm text-slate-700"><ChevronRight size={14} className="gold-text" />{f}</li>)}
              </ul>
              <div className="flex gap-3">
                <button onClick={() => trackAndGo(p.key)} className="btn-gold px-4 py-2.5 text-sm flex-1 inline-flex items-center justify-center gap-1" data-testid={`platforms-download-${p.key}`}>Download <ArrowUpRight size={14} /></button>
                <button onClick={() => trackAndGo(p.webKey)} className="btn-outline-gold px-4 py-2.5 text-sm flex-1" data-testid={`platforms-web-${p.key}`}>WebTrader</button>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
